var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon500(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 8.0829C76.1632 3.08119 86.8368 3.08119 95.5 8.0829L138.081 32.6671C146.744 37.6688 152.081 46.9124 152.081 56.9158V106.084C152.081 116.088 146.744 125.331 138.081 130.333L95.5 154.917C86.8368 159.919 76.1632 159.919 67.5 154.917L24.9189 130.333C16.2557 125.331 10.9189 116.088 10.9189 106.084V56.9158C10.9189 46.9124 16.2557 37.6688 24.9189 32.6671L67.5 8.0829Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13.3301C77.641 10.6506 83.359 10.6506 88 13.3301L135.787 40.9199C140.428 43.5994 143.287 48.5513 143.287 53.9103V109.09C143.287 114.449 140.428 119.401 135.787 122.08L88 149.67C83.359 152.349 77.641 152.349 73 149.67L25.2132 122.08C20.5721 119.401 17.7132 114.449 17.7132 109.09V53.9103C17.7132 48.5513 20.5721 43.5994 25.2132 40.9199L73 13.3301Z",
    fill: "url(#paint0_linear_170_11997)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16.7528C78.0222 14.4306 82.9778 14.4306 87 16.7528L133.323 43.4972C137.345 45.8195 139.823 50.1111 139.823 54.7556V108.244C139.823 112.889 137.345 117.181 133.323 119.503L87 146.247C82.9778 148.569 78.0222 148.569 74 146.247L27.6773 119.503C23.655 117.181 21.1773 112.889 21.1773 108.244V54.7556C21.1773 50.1111 23.655 45.8195 27.6773 43.4972L74 16.7528Z",
    fill: "url(#paint1_linear_170_11997)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 77C84.9633 77 76 85.9633 76 97C76 108.037 84.9633 117 96 117C107.037 117 116 108.037 116 97C116 85.9633 107.037 77 96 77ZM69.54 93.6667H52.6667C48.9833 93.6667 46 96.65 46 100.333V107C46 110.683 48.9833 113.667 52.6667 113.667H75.19C71.5267 109.1 69.3333 103.303 69.3333 97C69.3333 95.87 69.4033 94.76 69.54 93.6667ZM59.3333 100.333H56C54.16 100.333 52.6667 101.827 52.6667 103.667C52.6667 105.507 54.16 107 56 107H59.3333C61.1733 107 62.6667 105.507 62.6667 103.667C62.6667 101.827 61.1733 100.333 59.3333 100.333ZM91.2867 97L88.93 99.3567C87.6267 100.657 87.6267 102.77 88.93 104.07C90.23 105.373 92.3433 105.373 93.6433 104.07L96 101.713L98.3567 104.07C99.6567 105.373 101.77 105.373 103.07 104.07C104.373 102.77 104.373 100.657 103.07 99.3567L100.713 97L103.07 94.6433C104.373 93.3433 104.373 91.23 103.07 89.93C101.77 88.6267 99.6567 88.6267 98.3567 89.93L96 92.2867L93.6433 89.93C92.3433 88.6267 90.23 88.6267 88.93 89.93C87.6267 91.23 87.6267 93.3433 88.93 94.6433L91.2867 97ZM70.1733 90.3333C72.96 79.53 82.35 71.3701 93.7733 70.4267C93.4133 70.3634 93.0433 70.3333 92.6667 70.3333H52.6667C48.9833 70.3333 46 73.3167 46 77V83.6667C46 87.35 48.9833 90.3333 52.6667 90.3333H70.1733ZM59.3333 77H56C54.16 77 52.6667 78.4933 52.6667 80.3333C52.6667 82.1733 54.16 83.6667 56 83.6667H59.3333C61.1733 83.6667 62.6667 82.1733 62.6667 80.3333C62.6667 78.4933 61.1733 77 59.3333 77ZM99.3333 60.3333V53.6667C99.3333 49.9833 96.35 47 92.6667 47H52.6667C48.9833 47 46 49.9833 46 53.6667V60.3333C46 64.0167 48.9833 67 52.6667 67H92.6667C96.35 67 99.3333 64.0167 99.3333 60.3333ZM59.3333 53.6667H56C54.16 53.6667 52.6667 55.16 52.6667 57C52.6667 58.84 54.16 60.3333 56 60.3333H59.3333C61.1733 60.3333 62.6667 58.84 62.6667 57C62.6667 55.16 61.1733 53.6667 59.3333 53.6667Z",
    fill: "url(#paint2_linear_170_11997)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_11997",
    x1: 80.5,
    y1: 9,
    x2: 80.5,
    y2: 154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_170_11997",
    x1: 80.5,
    y1: 13,
    x2: 80.5,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_170_11997",
    x1: 81,
    y1: 47,
    x2: 81,
    y2: 117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon500);
export default __webpack_public_path__ + "static/media/icon_500.6adf8e69f688a782c0d022b87b07bfde.svg";
export { ForwardRef as ReactComponent };